import { imgMap } from '@/utils';

export default {
  data() {
    return {
      currentTab: 1,
      lineHeight: '55',
      marginRight: 50, // 距离右边的距离
      userName: '', // 用户名称
      scaleReturn: '--', // 直推返佣
      scaleSub: '--', // 子经济分佣
      reqData: {}, // 返回的数据
      reqReady: false, // 返回数据是否成功
      dialogFlag: false,
      dialogConfirmLoading: false,
      dialogConfirmDisabled: false,
      inviteCode: '',
      inviteUrl: '',
      inviteQECode: '',
      inviteCodeShow: true,
      inviteUrlShow: true,
    };
  },
  computed: {
    navTab() {
      return [
        {
          name: this.$t('brokerSystem.navTab[0]'),
          index: 1,
        },
        // {
        //   name: this.$t('brokerSystem.navTab[1]'),
        //   index: 2,
        // },
        {
          name: this.$t('brokerSystem.navTab[1]'),
          index: 3,
        },
        // {
        //   name: this.$t('brokerSystem.navTab[3]'),
        //   index: 4,
        // },
      ];
    },
    customStyle() {
      return {
        background: `url(${imgMap['jingji-header-bg']}) no-repeat right bottom`,
        backgroundSize: '438px 116px',
      };
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
  },
  watch: {
    userInfo(userinfo) { // 监听userinfo接口
      if (userinfo) {
        this.getUserInfo();// 获取用户信息
      }
    },
  },
  methods: {
    currentType(data) {
      this.currentTab = data.index;
    },
    getUserInfo() {
      if (this.userInfo !== null) {
        // 邀请码信息
        this.inviteCode = this.userInfo.inviteCode;
        this.inviteQECode = this.userInfo.inviteQECode;
        this.inviteUrl = this.userInfo.inviteUrl;
      }
    },
    inviteHelp() {
      // 推广助手
      this.dialogFlag = true;
    },
    dialogClose() { // 关闭或取消时
      this.dialogConfirmDisabled = false;
      this.dialogFlag = false;
    },
    dialogConfirm() {
      this.dialogFlag = false;
    },
    copyClick(name) {
      if (name === 'inviteCode') {
        this.copy(this.inviteCode);
      } else {
        this.copy(this.inviteUrl);
      }
    },
    copy(str) {
      this.$bus.$emit('tip', { text: this.$t('personal.prompt.copySucces'), type: 'success' });
      function save(e) {
        e.clipboardData.setData('text/plain', str); // 下面会说到clipboardData对象
        e.preventDefault(); // 阻止默认行为
      }
      document.addEventListener('copy', save);
      document.execCommand('copy'); // 使文档处于可编辑状态，否则无效
      document.removeEventListener('copy', save);
    },
    handMouseenter(name) {
      if (name === 'inviteCode') {
        this.inviteCodeShow = false;
      } else {
        this.inviteUrlShow = false;
      }
    },
    handMouseleave(name) {
      if (name === 'inviteCode') {
        this.inviteCodeShow = true;
      } else {
        this.inviteUrlShow = true;
      }
    },
    init() {
      this.getData();
    },
    getData() {
      this.axios({
        url: 'coAgent/getBrokerageInfo',
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.reqData = data.data;
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
  },
};
